import { render, staticRenderFns } from "./TrunkCostsAdmin.vue?vue&type=template&id=d6404cb4&scoped=true"
import script from "./TrunkCostsAdmin.vue?vue&type=script&lang=js"
export * from "./TrunkCostsAdmin.vue?vue&type=script&lang=js"
import style0 from "./TrunkCostsAdmin.vue?vue&type=style&index=0&id=d6404cb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6404cb4",
  null
  
)

export default component.exports